import { NavLink } from "react-router-dom";
import { ChevronRight, ChevronDown, MoreHorizontal, Pencil, Trash2, FolderPlus, Plus, ListChecks } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { cn } from "../../lib/utils";

export default function SpaceTreeItem({ space, projects, isOpen, onToggle, onDialog, onDeleteSpace, onDeleteProject }) {
  const spaceProjects = projects.filter((p) => p.space_id === space.id);
  return (
    <div className="mb-0.5">
      <div className="group flex items-center h-8 rounded-md hover:bg-muted pr-1">
        <button data-testid={`space-toggle-${space.id}`} onClick={() => onToggle(space.id)} className="px-1.5 text-muted-foreground">
          {isOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </button>
        <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{ backgroundColor: space.color }} />
        <NavLink to={`/space/${space.id}`} data-testid={`space-link-${space.id}`}
          className="flex-1 px-2 text-sm font-medium truncate text-foreground/90 hover:text-foreground">
          {space.name}
        </NavLink>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button data-testid={`space-menu-${space.id}`} className="h-6 w-6 hidden group-hover:flex items-center justify-center rounded text-muted-foreground hover:text-foreground">
              <MoreHorizontal size={14} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-44">
            <DropdownMenuItem data-testid={`space-add-project-${space.id}`} onClick={() => onDialog({ type: "project", mode: "create", spaceId: space.id })}>
              <FolderPlus size={14} className="mr-2" />Add project
            </DropdownMenuItem>
            <DropdownMenuItem data-testid={`space-edit-${space.id}`} onClick={() => onDialog({ type: "space", mode: "edit", entity: space })}>
              <Pencil size={14} className="mr-2" />Rename
            </DropdownMenuItem>
            <DropdownMenuItem data-testid={`space-delete-${space.id}`} className="text-[#E31E24]" onClick={() => onDeleteSpace(space)}>
              <Trash2 size={14} className="mr-2" />Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {isOpen && (
        <div className="ml-6 border-l border-border pl-2 space-y-0.5 task-row-enter">
          {spaceProjects.map((p) => (
            <div key={p.id} className="group flex items-center h-7 rounded-md hover:bg-muted pr-1">
              <NavLink to={`/project/${p.id}`} data-testid={`project-link-${p.id}`}
                className={({ isActive }) => cn("flex-1 flex items-center gap-2 px-2 text-[13px] truncate transition-colors",
                  isActive ? "text-[#E31E24] font-semibold" : "text-muted-foreground hover:text-foreground")}>
                <ListChecks size={13} />{p.name}
              </NavLink>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button data-testid={`project-menu-${p.id}`} className="h-5 w-5 hidden group-hover:flex items-center justify-center rounded text-muted-foreground hover:text-foreground">
                    <MoreHorizontal size={13} />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" className="w-40">
                  <DropdownMenuItem data-testid={`project-edit-${p.id}`} onClick={() => onDialog({ type: "project", mode: "edit", entity: p })}>
                    <Pencil size={14} className="mr-2" />Rename
                  </DropdownMenuItem>
                  <DropdownMenuItem data-testid={`project-delete-${p.id}`} className="text-[#E31E24]" onClick={() => onDeleteProject(p)}>
                    <Trash2 size={14} className="mr-2" />Delete
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          ))}
          <button data-testid={`add-project-inline-${space.id}`} onClick={() => onDialog({ type: "project", mode: "create", spaceId: space.id })}
            className="flex items-center gap-2 px-2 h-7 text-[13px] text-muted-foreground hover:text-[#E31E24] transition-colors w-full rounded-md hover:bg-muted">
            <Plus size={13} />Add project
          </button>
        </div>
      )}
    </div>
  );
}
